"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.monthLongName = exports.padZeroNumber = exports.last = void 0;
exports.last = function (array) { return array[array.length - 1]; };
exports.padZeroNumber = function (value) { return ("" + value).padStart(2, '0'); };
/**
 * Форматирование названия месяца.
 * Если не передавать `day`, то название месяца будет, например, `июнь`.
 * В данном случае вернется `июня`.
 * Так же результат выполнения метода `formatToParts` является массивом,
 * в котором находятся части даты, форматированной на основнии `options`.
 * То есть в данном случае вернется массив [`day`, `separator`, `month`]
 */
exports.monthLongName = function (val) {
    return exports.last(new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long' }).formatToParts(new Date().setMonth(val)))
        .value;
};
//# sourceMappingURL=formatters.js.map